export default __webpack_public_path__ + "static/2467-bbf6c5f80dfdd6a40b92926c9bda0a39.jpeg";